module.exports = __webpack_public_path__ + "img/selfoptimisation.c14fd2e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/mlstudio/selfoptimisation.svg
// module id = iet8
// module chunks = 39 44